import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import {
  DashboardInvoiceCountsKPIReeuestDTO,
  HospitalInvoiceMasterCreateRequestDTO,
  HospitalInvoiceMasterDeleteRequestDTO,
  HospitalInvoiceMasterDTO,
  HospitalInvoiceMasterList,
  HospitalInvoiceMasterReadAllPaginatedRequestDTO,
  HospitalInvoiceMasterReadByHospitalIdRequestDTO,
  HospitalInvoiceMasterReadByIdRequestDTO,
  HospitalInvoiceMasterReadByUserIdRequestDTO,
  HospitalInvoiceMasterUpdateRequestDTO,
  InvoiceMasterOnwerDashboardReadRequestDTO,
  InvoiceMasterOnwerDashboardReadResponseDTO,
  UserAffiliationMappingReadAllUserPaginatedRequestDTO,
} from "./hospital-billing.interface";
import { Observable } from "rxjs";
import {
  HospitalInvoiceMaster_Create,
  HospitalInvoiceMaster_Delete,
  HospitalInvoiceMaster_InvoiceMasterOwnerDashboardRead,
  // HospitalInvoiceMaster_ReadAll,
  HospitalInvoiceMaster_ReadAllPaginated,
  HospitalInvoiceMaster_ReadByHospitalId,
  HospitalInvoiceMaster_ReadById,
  HospitalInvoiceMaster_ReadByUserId,
  HospitalInvoiceMaster_Update,
} from "src/app/GlobalVariable/Hospital.GlobalVariable";
import { HUserAffiliationMapping_ReadAllUserPaginated } from "src/app/GlobalVariable";

@Injectable({
  providedIn: "root",
})
export class HospitalInvoiceMasterService {
  http = inject(HttpClient);

  HosptialInvoiceMaster_Create(
    data: HospitalInvoiceMasterCreateRequestDTO
  ): Observable<HospitalInvoiceMasterDTO> {
    return this.http.post<HospitalInvoiceMasterDTO>(
      HospitalInvoiceMaster_Create,
      data
    );
  }

  // HospitalInvoiceMaster_ReadAll(): Observable<HospitalInvoiceMasterList> {
  //   return this.http.get<HospitalInvoiceMasterList>(
  //     HospitalInvoiceMaster_ReadAll
  //   );
  // }

  HospitalInvoiceMaster_ReadByHospitalId(
    data: HospitalInvoiceMasterReadByHospitalIdRequestDTO
  ): Observable<HospitalInvoiceMasterList> {
    return this.http.post<HospitalInvoiceMasterList>(
      HospitalInvoiceMaster_ReadByHospitalId,
      data
    );
  }

  HospitalInvoiceMaster_ReadAllPaginated(
    data: HospitalInvoiceMasterReadAllPaginatedRequestDTO
  ): Observable<HospitalInvoiceMasterList> {
    return this.http.post<HospitalInvoiceMasterList>(
      HospitalInvoiceMaster_ReadAllPaginated,
      data
    );
  }

  HospitalInvoiceMaster_ReadByUserId(
    data: HospitalInvoiceMasterReadByUserIdRequestDTO
  ): Observable<HospitalInvoiceMasterList> {
    return this.http.post<HospitalInvoiceMasterList>(
      HospitalInvoiceMaster_ReadByUserId,
      data
    );
  }

  HospitalInvoiceMaster_ReadById(
    data: HospitalInvoiceMasterReadByIdRequestDTO
  ): Observable<HospitalInvoiceMasterDTO> {
    return this.http.post<HospitalInvoiceMasterDTO>(
      HospitalInvoiceMaster_ReadById,
      data
    );
  }

  HospitalInvoiceMaster_Update(
    data: HospitalInvoiceMasterUpdateRequestDTO
  ): Observable<HospitalInvoiceMasterDTO> {
    return this.http.post<HospitalInvoiceMasterDTO>(
      HospitalInvoiceMaster_Update,
      data
    );
  }

  HospitalInvoiceMaster_Delete(
    data: HospitalInvoiceMasterDeleteRequestDTO
  ): Observable<void> {
    return this.http.post<void>(HospitalInvoiceMaster_Delete, data);
  }



  HospitalInvoiceMaster_GetBillingOverviewWithFilter(
    data: InvoiceMasterOnwerDashboardReadRequestDTO
  ): Observable<InvoiceMasterOnwerDashboardReadResponseDTO> {
    return this.http.post<InvoiceMasterOnwerDashboardReadResponseDTO>(
      HospitalInvoiceMaster_InvoiceMasterOwnerDashboardRead,
      data
    );
  }

  // ============================================================
  // USER AFFILIATION MAPPING - READ ALL USER PAGINATED
  // Used only by Add Invoice patient search.
  // Existing invoice APIs/flow remain unchanged.
  // ============================================================
  HospitalUserAffiliation_ReadAllUserPaginated(
    data: UserAffiliationMappingReadAllUserPaginatedRequestDTO
  ): Observable<any> {
    return this.http.post<any>(
      HUserAffiliationMapping_ReadAllUserPaginated,
      data
    );
  }
}
